export default function DAPsConfiguration($translatePartialLoaderProvider) {
    $translatePartialLoaderProvider.addPart('daps');
}

DAPsConfiguration.$inject = ['$translatePartialLoaderProvider'];
